import React, { useCallback, useState } from 'react';
import { Form, Col, Row, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Modal } from '../util';
import { Button } from '../util/buttons';
import { useErrorHandling } from '../hooks/useErrorHandling';
import userAccessService from '../services/user_access.service';
const ClientReviewMailerModal = _ref => {
  let {
    show,
    claimGroup,
    setClaimGroup,
    loading,
    createChangeSetForClient,
    reviewType,
    reviewedObjectClass,
    reviewedObject,
    setModalShow
  } = _ref;
  const {
    t
  } = useTranslation();
  const [disabled, setDisabled] = useState(!reviewedObject.change_sets.find(cs => cs.review_type === 'consultant_review'));
  const selectEmails = useErrorHandling(useCallback(async (event, userAccessId, claimGroupToUpdate) => {
    const newUserAccess = await userAccessService.update(claimGroupToUpdate.id, {
      id: userAccessId,
      include_in_client_review_email: event.target.checked
    });
    const userAceessIndex = claimGroupToUpdate.user_accesses.findIndex(uA => uA.id === userAccessId);
    claimGroupToUpdate.user_accesses[userAceessIndex] = {
      ...newUserAccess
    };
    setClaimGroup({
      ...claimGroupToUpdate
    });
  }, [setClaimGroup]));
  const sendEmailAndStartReview = async shouldSendEmail => {
    createChangeSetForClient(reviewedObject, reviewedObjectClass, reviewType, shouldSendEmail, setModalShow);
  };
  const translatedRoles = roles => roles.map(r => t(r)).join(', ');
  const clientContactOptions = claimGroup.user_accesses.filter(uA => uA.user).sort((a, b) => a.id - b.id).map(uA => {
    return /*#__PURE__*/React.createElement("div", {
      key: uA.id
    }, /*#__PURE__*/React.createElement(Form.Check, {
      checked: uA.include_in_client_review_email,
      name: 'email',
      label: uA.user.name + ' - ' + translatedRoles(uA.roles),
      onChange: e => selectEmails(e, uA.id, claimGroup)
    }));
  });
  const claimgGroupHaveClientSponsor = claimGroup.user_accesses.some(uA => uA.roles.some(r => r === 'client_sponsor'));
  const noClientSponsorMessage = /*#__PURE__*/React.createElement("p", null, "You've not selected a Client Sponsor, please go into the 'Engagement Team' section of Advance and appoint a client sponsor before setting this claim to a Client Review state");
  const modalBody = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, disabled && /*#__PURE__*/React.createElement(Alert, {
      variant: "danger"
    }, "Please finish manager review first"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 12
    }, /*#__PURE__*/React.createElement("p", null, "You are about to send an email notification to your client requesting that they login to Advance and review their R&D Claim report for claim: ", claimGroup.name))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 12
    }, /*#__PURE__*/React.createElement("p", null, "If you want to send this email please select from the Engagement team members who you would like to receive this email, once done click on the Send Email button"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 12
    }, /*#__PURE__*/React.createElement("p", null, "Check Box to Include in Email:"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 8
    }, claimgGroupHaveClientSponsor ? clientContactOptions : noClientSponsorMessage), /*#__PURE__*/React.createElement(Col, {
      md: 4
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "info",
      iconPosition: "left",
      icon: "mail",
      loading: loading,
      disabled: disabled,
      onClick: () => sendEmailAndStartReview(true)
    }, t('send_email_and_start_the_client_review')))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 12
    }, /*#__PURE__*/React.createElement("p", null, "If you want to start this review but not send an email to the client click the below 'Start Client Review but do not send email' button"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 8
    }), /*#__PURE__*/React.createElement(Col, {
      md: 4
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "info",
      iconPosition: "left",
      icon: "mail",
      loading: loading,
      disabled: disabled,
      onClick: () => sendEmailAndStartReview(false)
    }, t('do_not_send_the_email_but_start_the_client_review')))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 12
    }, /*#__PURE__*/React.createElement("p", null, "If you want to abort this request click the Cancel button and the client review will not be started."))));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    size: "xl",
    renderBody: () => modalBody(),
    onHide: () => setModalShow(false)
  });
};
export default ClientReviewMailerModal;